import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';

import { Col } from 'reactstrap';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getAcademicOffers } from '../api';
import { AcademicOfferResponse } from '../types';

export interface HeaderLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  AcademicOfferResponse,
  AxiosResultDefaultError
>();

export const useAcademicOffer = () => {
  const { data } = useFetch();
  return data?.map((academicOffer) => ({
    value: academicOffer.id,
    label: academicOffer.periodName,
  }));
};

export const HeaderLoaderConsumer = FetchConsumer;

export function HeaderLoader({ children }: HeaderLoaderProps) {
  const request = useCallback(async () => {
    return getAcademicOffers();
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <Col md={12}>
                <DisplayError
                  insideCard
                  textBody={error.code}
                  retryAction={refresh}
                  loadingAction={loading}
                />
              </Col>
            );
          }
          if (loading) {
            return (
              <Col md={12}>
                <Loading insideCard />
              </Col>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
